/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import { css } from '@emotion/react';
import { logicalCSS } from '../../../global_styling';
export var euiDataGridPaginationStyles = function euiDataGridPaginationStyles(_ref) {
  var euiTheme = _ref.euiTheme;
  return {
    euiDataGrid__pagination: /*#__PURE__*/css("z-index:2;flex-grow:0;", logicalCSS('padding-top', euiTheme.size.xs), " .euiDataGrid--fullScreen &{position:relative;", logicalCSS('padding-bottom', euiTheme.size.xs), " background-color:", euiTheme.colors.lightestShade, ";&::before{content:'';position:absolute;", logicalCSS('top', "-".concat(euiTheme.border.width.thin)), " ", logicalCSS('horizontal', 0), " ", logicalCSS('border-top', euiTheme.border.thin), " pointer-events:none;}};label:euiDataGrid__pagination;")
  };
};